import '.cl{flex-shrink:0;}.ssr-plugin'
import '.cn{padding:1rem;}.ssr-plugin'
import '.a2{width:100%;}.ssr-plugin'
import '.bk{height:100%;}.ssr-plugin'
import '.av{border:none;}.ssr-plugin'
import '.aw{background-color:transparent;}.ssr-plugin'
import '.fi{border-radius:0px;}.ssr-plugin'
import '.i{display:flex;}.ssr-plugin'
import '.r{flex-direction:column;}.ssr-plugin'
import '.ab{align-items:stretch;}.ssr-plugin'
import '.ce{position:sticky;}.ssr-plugin'
import '.fj{top:4rem;}.ssr-plugin'
import '.fk{z-index:7;}.ssr-plugin'
import '.ae{background-color:var(--shades-white);}.ssr-plugin'
import '.fl{padding-bottom:1rem;}.ssr-plugin'
import '.a0{margin-bottom:1rem;}.ssr-plugin'
import '.fm{border-bottom:var(--blue-border);}.ssr-plugin'
import '.x{position:fixed;}.ssr-plugin'
import '.cf{top:0px;}.ssr-plugin'
import '.bi{left:0px;}.ssr-plugin'
import '.bj{right:0px;}.ssr-plugin'
import '.fn{bottom:0px;}.ssr-plugin'
import '.ev{z-index:9999;}.ssr-plugin'
import '.fo{transition:transform 0.3s ease-in-out;}.ssr-plugin'
import '.d7{justify-content:flex-end;}.ssr-plugin'
import '.cu{flex:1;}.ssr-plugin'
import '.b8{overflow-y:auto;}.ssr-plugin'
import { Style, styled } from 'inlines'
import {
  isValidElement,
  PropsWithChildren,
  ReactNode,
  useState,
  useEffect,
} from 'react'
import { useLocation } from 'wouter'
import { Button } from '@app/components/core/button/Button'
import { CloseButton } from '@app/components/core/button/CloseButton'

interface LeftSidebarMobileProps {
  sidebar: ReactNode
  content: ReactNode[]
}

const Sidebar = ({
  children,
  style,
}: PropsWithChildren & { style?: Style }) => {
  return (
    <styled.aside className="cl cn a2 bk av aw fi"
      style={{
        ...style,
      }}
    >
      {children}
    </styled.aside>
  )
}

export const LeftSidebarMobile = ({
  sidebar,
  content,
}: LeftSidebarMobileProps) => {
  const [isOpen, setIsOpen] = useState(false)
  const [location] = useLocation()

  // Close sidebar when route changes
  useEffect(() => {
    setIsOpen(false)
  }, [location])

  const collapsedButtonLabel =
    (isValidElement(sidebar) && sidebar.props.collapsedButtonLabel) || 'Menu'

  const sidebarContent = isValidElement(sidebar) ? sidebar.props.children : null
  const sidebarStyle = isValidElement(sidebar) ? sidebar.props.style : undefined

  return (
    <div className="i r ab"
    >
      <div className="ce fj fk ae fl a0 fm i"
      >
        <Button
          variant="link"
          label={collapsedButtonLabel}
          onClick={() => setIsOpen(true)}
        />
      </div>

      <div className="x cf bi bj fn ev ae fo i r"
        style={{
          transform: isOpen ? 'translateX(0)' : 'translateX(-100%)',}}
      >
        <div className="cn i d7 fm"
        >
          <CloseButton onClick={() => setIsOpen(false)} />
        </div>
        <div className="cu b8">
          <Sidebar style={sidebarStyle}>{sidebarContent}</Sidebar>
        </div>
      </div>

      {content}
    </div>
  )
}
